import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-3xl mx-auto bg-white p-6 sm:p-10 shadow-sm border border-gray-200">
        
        {/* Page Header */}
        <div className="border-b border-gray-200 pb-6 mb-8 text-center sm:text-left">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
            Privacy Policy
          </h1>
          <p className="text-xs sm:text-sm text-gray-500 mt-2">
            Last Updated: {new Date().toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })}
          </p>
        </div>

        {/* Introduction / Statement of Intent */}
        <p className="text-sm text-gray-600 leading-relaxed mb-8">
          This website is not the official one; it is only meant to be used for informative purposes. In our commitment to safeguarding your personal information, we have formulated this comprehensive privacy policy to protect your interests and data on our website.
        </p>

        {/* Policy Sections */}
        <div className="space-y-6">
          
          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              Update of Privacy Policy
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              This privacy policy is open to revision and review at any time, without notification or consent. Therefore, please re-visit the website and regularly go through the terms and conditions of this privacy policy to stay informed about the modifications that have been made.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              User Information
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              By accessing our website, you accept our terms and give permission for us to collect and use any information you voluntarily submit. While certain visits might not require personal information, others could in order to provide access to particular links or websites. We use the information you have given us to deliver information and updates, confirm receipt of your message, and offer pertinent goods and services. We do not share personal information with outside parties, and you have the option to unsubscribe from our email list.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              Security
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Sensitive information is encrypted during transmission between the client and server. We restrict employee access to your personal information and hold them to high levels of confidentiality. We may use cookies for security, session continuity, and customization purposes. Rejecting cookies may limit your access to certain services or features.
            </p>
          </section>

        </div>

        {/* Closing Notice Footer */}
        <div className="mt-8 p-4 bg-gray-50 border border-gray-100 text-center text-xs text-gray-500 italic">
          This website is not the official one; it is only meant to be used for informative purposes.
        </div>

        {/* Home Navigation Route */}
        <div className="mt-8 pt-6 border-t border-gray-200 text-center">
          <a 
            href="/" 
            className="text-xs sm:text-sm text-[#007BFF] hover:underline font-medium"
          >
            ← Back to Homepage
          </a>
        </div>

      </div>
    </div>
  );
}